import React from 'react';
import PropTypes from 'prop-types';
import tastify from '@frontastic/catwalk/src/js/helper/tastify';
import MediaTextTeaser from '../../../components/organisms/mediaTextTeaser';

const SplitMediaSectionTastic = ({ data, context }) => {
  if (!data) return null;

  const locale = context?.locale === 'en_AU@AUD' ? 'AU' : 'NZ';

  if (!data[`show${locale}`]) return null;

  return <MediaTextTeaser {...data} />;
};

SplitMediaSectionTastic.propTypes = {
  data: PropTypes.object.isRequired,
};

export default tastify({
  translate: true,
  connect: { context: true },
})(SplitMediaSectionTastic);
